import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { FaPlus, FaTrash, FaArrowLeft, FaFileAlt, FaLink } from "react-icons/fa";
import styles from "./SifatSiyosati.module.css";
import { testUrl } from "../home/BaseData";

const SifatSiyosatiSD = () => {
    const { t, i18n } = useTranslation();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const mode = searchParams.get("mode") || "view"; // 'edit' or 'view'

    const [sdData, setSdData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isEditFormOpen, setIsEditFormOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const fetchSDData = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${testUrl}/api/quality-policy-sd/`);
            setSdData(response.data);
        } catch (error) {
            console.error("Error fetching SD data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSDData();
    }, [i18n.language]);

    const handleBack = () => {
        navigate("/documents/sifat-siyosati");
    };

    const handleSDSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const file = formData.get('file');

        // If it's an update and no new file is selected, remove it from formData
        // so it doesn't overwrite the existing file with an empty one in DRF
        if (selectedItem && (!file || file.size === 0)) {
            formData.delete('file');
        }

        try {
            if (selectedItem) {
                await axios.patch(`${testUrl}/api/quality-policy-sd/${selectedItem.id}/`, formData);
            } else {
                await axios.post(`${testUrl}/api/quality-policy-sd/`, formData);
            }
            fetchSDData();
            setIsEditFormOpen(false);
            setSelectedItem(null);
        } catch (error) {
            console.error("Error saving SD:", error);
            alert("Xatolik yuz berdi");
        }
    };

    const handleSDDelete = async (id) => {
        if (window.confirm("Ushbu SD kodni o'chirib tashlamoqchimisiz?")) {
            try {
                await axios.delete(`${testUrl}/api/quality-policy-sd/${id}/`);
                fetchSDData();
            } catch (error) {
                console.error("Error deleting SD:", error);
            }
        }
    };

    if (loading) {
        return (
            <div className={styles.mainContainer}>
                <div className={styles.loading}>{t("loading") || "Yuklanmoqda..."}</div>
            </div>
        );
    }

    return (
        <div className={styles.mainContainer} style={{ background: '#f4f7f9' }}>
            <div className={styles.container} style={{ maxWidth: '1300px', padding: '0 20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '24px', marginBottom: '40px', borderBottom: '1px solid #e2e8f0', paddingBottom: '20px' }}>
                    <button onClick={handleBack} className={styles.closeBtn} style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', width: '48px', height: '48px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', transition: 'all 0.2s' }}>
                        <FaArrowLeft size={18} color="#1a365d" />
                    </button>
                    <div>
                        <h1 style={{ margin: 0, fontSize: '32px', color: '#1a365d', fontWeight: '800', letterSpacing: '-0.5px' }}>
                            Hujjatlar ro'yxati
                        </h1>
                    </div>
                </div>

                {mode === 'edit' && (
                    <button className={styles.sdAddIconButton} onClick={() => { setSelectedItem(null); setIsEditFormOpen(true); }}>
                        <FaPlus size={20} />
                    </button>
                )}

                <div className={styles.sdTableWrapper} style={{ marginTop: '20px' }}>
                    <table className={styles.sdTableContainer}>
                        <thead>
                            <tr>
                                <th>SD kodi</th>
                                <th>Tavsif va Ma'lumot</th>
                                <th>Havola</th>
                                <th>Fayl</th>
                                {mode === 'edit' && <th className={styles.sdActionCell}>Amallar</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {sdData && sdData.length > 0 ? (
                                sdData.map((sd) => (
                                    <tr key={sd.id}>
                                        <td className={styles.sdCodeCell}>
                                            <span className={styles.sdCodeBadge}>
                                                {sd.sd_code}
                                            </span>
                                        </td>
                                        <td>
                                            <div style={{ fontWeight: '500', color: '#1e293b' }}>
                                                {sd[`description_${i18n.language}`] || sd.description_uz}
                                            </div>
                                        </td>
                                        <td>
                                            {sd.link ? (
                                                <a href={sd.link} target="_blank" rel="noreferrer" className={styles.sdLink} style={{ fontSize: '12px', wordBreak: 'break-all' }}>
                                                    {sd.link}
                                                </a>
                                            ) : (
                                                <span style={{ color: '#cbd5e1', fontSize: '13px' }}>—</span>
                                            )}
                                        </td>
                                        <td>
                                            {sd.file ? (
                                                <a href={sd.file} target="_blank" rel="noreferrer" className={`${styles.sdLink} ${styles.sdFileLink}`}>
                                                    <FaFileAlt size={14} /> Fayl
                                                </a>
                                            ) : (
                                                <span style={{ color: '#cbd5e1', fontSize: '13px' }}>—</span>
                                            )}
                                        </td>
                                        {mode === 'edit' && (
                                            <td className={styles.sdActionCell}>
                                                <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                                                    <button
                                                        className={styles.deleteBtn}
                                                        style={{ padding: '6px 12px', background: '#f1f5f9', color: '#475569', borderRadius: '6px', fontSize: '12px' }}
                                                        onClick={() => { setSelectedItem(sd); setIsEditFormOpen(true); }}
                                                    >
                                                        Edit
                                                    </button>
                                                    <button
                                                        className={styles.deleteBtn}
                                                        style={{ padding: '6px', minWidth: '32px' }}
                                                        onClick={() => handleSDDelete(sd.id)}
                                                    >
                                                        <FaTrash size={12} />
                                                    </button>
                                                </div>
                                            </td>
                                        )}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={mode === 'edit' ? 5 : 4} style={{ textAlign: 'center', padding: '100px', color: '#94a3b8' }}>
                                        Ma'lumotlar mavjud emas
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Edit Form Modal */}
            {isEditFormOpen && (
                <div className={styles.modalOverlay} style={{ zIndex: 10000 }}>
                    <div className={`${styles.modalContent} ${styles.sdEditModal}`} style={{ maxWidth: '650px', borderRadius: '24px', padding: '40px' }}>
                        <div className={styles.modalHeader}>
                            <h2 style={{ fontSize: '24px', fontWeight: '800' }}>{selectedItem ? 'SD Ma\'lumotni tahrirlash' : 'Yangi SD qo\'shish'}</h2>
                            <button className={styles.closeBtn} onClick={() => setIsEditFormOpen(false)}>&times;</button>
                        </div>
                        <form onSubmit={handleSDSubmit} className={styles.formList}>
                            <div className={styles.inputGroup}>
                                <label style={{ fontSize: '14px', marginBottom: '8px', display: 'block' }}>SD Kodi</label>
                                <input name="sd_code" className={styles.inputField} defaultValue={selectedItem?.sd_code} required style={{ padding: '14px' }} />
                            </div>
                            <div className={styles.inputGroup}>
                                <label style={{ fontSize: '14px', marginBottom: '8px', display: 'block' }}>Tavsif</label>
                                <textarea name="description_uz" className={styles.textareaField} defaultValue={selectedItem?.description_uz} required style={{ minHeight: '120px', padding: '14px' }} />
                            </div>
                            <div className={styles.inputGroup}>
                                <label style={{ fontSize: '14px', marginBottom: '8px', display: 'block' }}>Havola (URL)</label>
                                <input name="link" type="url" className={styles.inputField} defaultValue={selectedItem?.link} placeholder="https://..." style={{ padding: '14px' }} />
                            </div>
                            <div className={styles.inputGroup}>
                                <label style={{ fontSize: '14px', marginBottom: '8px', display: 'block' }}>Fayl yuklash (PDF)</label>
                                <input name="file" type="file" accept=".pdf" className={styles.inputField} style={{ padding: '10px' }} />
                                {selectedItem?.file && <p style={{ fontSize: '12px', marginTop: '8px', color: '#64748b' }}>Hozirgi fayl: {selectedItem.file.split('/').pop()}</p>}
                            </div>
                            <div className={styles.footerActions} style={{ marginTop: '30px' }}>
                                <button type="submit" className={styles.saveBtn} style={{ padding: '16px', borderRadius: '12px', fontSize: '16px' }}>
                                    Ma'lumotlarni saqlash
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SifatSiyosatiSD;
